import qs from 'qs';

export default  (obj, addQueryPrefix = true, indices) => {
    return qs.stringify(obj, {
        strictNullHandling: true,
        addQueryPrefix: addQueryPrefix,
        indices,
    });
};
